import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vision-mission',
  templateUrl: './vision-mission.component.html',
  styleUrls: ['./vision-mission.component.css']
})
export class VisionMissionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
